module.exports = __webpack_public_path__ + "static/fipctransport3-2a37a822d1c6f66e5357d02687e3514c.jpeg";